import { render, staticRenderFns } from "./ReservationConfirmed.vue?vue&type=template&id=594ea935&"
import script from "./ReservationConfirmed.vue?vue&type=script&lang=js&"
export * from "./ReservationConfirmed.vue?vue&type=script&lang=js&"
import style0 from "./ReservationConfirmed.vue?vue&type=style&index=0&id=594ea935&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('594ea935')) {
      api.createRecord('594ea935', component.options)
    } else {
      api.reload('594ea935', component.options)
    }
    module.hot.accept("./ReservationConfirmed.vue?vue&type=template&id=594ea935&", function () {
      api.rerender('594ea935', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/ReservationConfirmed.vue"
export default component.exports